import { routes } from '../../src/router/routes'
import _ from 'lodash'
import center from '@turf/center'
import wellknown from 'wellknown'

export const getComponentName = path => {
  const theRoutes = routes.filter(route => {
    if (route.path === path) {
      return true
    } else {
      return false
    }
  })
  return theRoutes[0] ? theRoutes[0].title : 'no_page_name'
}

export const checkForToken = returnToken => {
  const token =
    window.localStorage.getItem('accessToken') ||
    window.sessionStorage.getItem('accessToken')
  if (returnToken) {
    return token
  }
  return token ? true : false
}

export const clearToken = () => {
  window.localStorage.removeItem('accessToken')
  window.sessionStorage.removeItem('accessToken')
}

export const clearStorage = () => {
  window.localStorage.removeItem('context')
  window.localStorage.removeItem('accessToken')
  window.sessionStorage.removeItem('accessToken')
}

export const formatPhoneNumber = phoneNumberString => {
  if (
    typeof phoneNumberString === 'string' &&
    phoneNumberString.toLowerCase() !== 'null'
  ) {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3]
    }
  }
  return 'N/A'
}

export const reducePhoneNumber = phoneNumberString => {
  let reduced = phoneNumberString ? phoneNumberString.replace(/[^\d+]/g, '') : 'N/A'
  if (reduced && reduced.length === 10) {
    reduced = '1' + reduced
  } else if (reduced.length === 0) {
    reduced = 'N/A'
  }
  return reduced
}

export const handleSigners = _signers => {
  const signers = _signers.map(signer => {
    return {
      id: signer.contract_signer_id,
      title: 'Name',
      value: `${nullParser(signer.first_name)} ${nullParser(signer.last_name)}`,
      contract_status: signer.approval_timestamp
        ? 'signed'
        : 'awaiting signature',
      approval_timestamp: signer.approval_timestamp,
      title_stamp: 'Contract signed on',
      contract_timestamp: signer.approval_timestamp,
      user_id: signer.external_reference_id,
      phone: signer.origPhone !== 'null' ? signer.origPhone : signer.phone,
      origPhone: signer.origPhone !== 'null' ? signer.phone : signer.origPhone,
      delivery_choice: signer.delivery_choice,
      email: signer.email,
      signed_here: signer.signed_here || null
    }
  })
  if (signers.length >= 2) {
    const halfWay = signers.length / 2
    return [signers.slice(0, halfWay), signers.slice(halfWay)]
  } else if (signers.length === 1) {
    return [signers]
  }
  return signers
}

export const splitBySpace = splittable => {
  const firstAndSecond = splittable.split(/ (.*)/,2)
  if (!firstAndSecond[0]) {
    firstAndSecond[0] = 'N/A'
  }
  if (!firstAndSecond[1]) {
    firstAndSecond[1] = 'N/A'
  }
  return firstAndSecond
}


export const convertToSentenceCase = string => {
  if (string && string.includes('-')) {
    const splitString = string.split('-')
    const capitalizedString = splitString.map(word => {
      if (splitString.indexOf(word) === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1)
      } else {
        return word.toLowerCase()
      }
    })
    return (
      capitalizedString.join(' ')
    )
  } else if (string && string.includes(' ')) {
    const splitString = string.split(' ')
    const capitalizedString = splitString.map(word => {
      if (splitString.indexOf(word) === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1)
      } else {
        return word.toLowerCase()
      }
    })
    return (
      capitalizedString.join(' ')
    )
  } else {
    return string && string.charAt(0).toUpperCase() + string.slice(1)
  }
}

export const convertToTitleCase = string => {
  let lowercasedString = string?.toLowerCase()
  if (lowercasedString && lowercasedString.includes(' ')) {
    const splitString = lowercasedString.split(' ')
    const capitalizedString = splitString.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1) + ' '
    })
    return (
      capitalizedString.join('')
    )
  } else {
    return lowercasedString && lowercasedString.charAt(0).toUpperCase() + lowercasedString.slice(1)
  }
}

export const nullParser = (val, replacer = 'N/A') => {
  let result = val
  if (
    (typeof val === 'string' && val.toLowerCase() === 'null') ||
    val === null ||
    val === undefined
  ) {
    result = replacer
  }
  return result
}

export const nullParserReverse = (val, shouldBeNull = 'N/A') => {
  return val === shouldBeNull ? null : val
}


export const generateYearsOptions = (_startYear, numberOfYears) => {
  const startYear = new Date(`${_startYear}-12-01`).getFullYear()
  const yearsArray = []
  for (let i = 0;i < numberOfYears;i++) {
    yearsArray.push({
      id: startYear + i,
      value: startYear + i
    })
  }
  return yearsArray
}

export const checkForPhoneNumber = user => {
  const _user = { ...user }
  if (!_user.phone) {
    const user_phone = window.localStorage.getItem('user_phone')
    if (user_phone) {
      _user.phone = user_phone
    }
  }
  if (_user.phone && _user.phone.length === 10) {
    _user.phone = '1' + _user.phone
  }
  return _user
}

export const getContractSignerId = (signers, phoneNumber) => {
  const ofInterest = signers.filter(signer => {
    if (signer.phone === phoneNumber) {
      return true
    } else if ('1' + signer.phone === phoneNumber) {
      return true
    } else if (signer.phone === '1' + phoneNumber) {
      return true
    } else {
      return false
    }
  })
  return ofInterest.length ? ofInterest[0].contract_signer_id : null
}

export const cacheIt = (whichFunc, result) => {
  window.localStorage.setItem(whichFunc, JSON.stringify(result))
  return result
}

export const customSort = (tableData, dataKey, sortBy) => {
  if (dataKey) {
    let newTableData = []
    if (sortBy === 'asc') {
      newTableData = [...tableData].sort((a, b) => {
        if(dataKey === 'nameObj'){
          return a[dataKey]['name'].toLowerCase() > b[dataKey]['name'].toLowerCase() ? 1 : -1
        } else if(dataKey === 'grower_name'){
          return a[dataKey].toLowerCase() > b[dataKey].toLowerCase() ? 1 : -1
        }else if(dataKey === 'scale_ticket_date'){
          return new Date(a.scale_ticket_date) - new Date(b.scale_ticket_date)
        } else if(dataKey === 'original_new_contract_id'){
          if(a.original_new_contract_id !== null && b.original_new_contract_id !== null) {
            const orgContracta =  a[dataKey].replace(/\D/g, '')
            const orgContractb =  b[dataKey].replace(/\D/g, '')
            return parseInt(orgContracta) - parseInt(orgContractb)
          }
          else
            return 0
        } else if(dataKey === 'company_name'){
          return a[dataKey].title.toLowerCase() > b[dataKey].title.toLowerCase() ? 1 : -1
        } else if(isNaN(parseInt(a[dataKey]))){
          return b[dataKey].toLowerCase() > a[dataKey].toLowerCase() ? -1 : 1
        } else {
          return parseInt(a[dataKey].replace(/,/g, '')) - parseInt(b[dataKey].replace(/,/g, ''))
        } 
      })
    } else {
      newTableData = [...tableData].sort((a, b) => {
        if(dataKey === 'nameObj'){
          return a[dataKey]['name'].toLowerCase() > b[dataKey]['name'].toLowerCase() ? -1 : 1
        } else if(dataKey === 'grower_name'){
          return a[dataKey].toLowerCase() > b[dataKey].toLowerCase() ? -1 : 1
        } else if(dataKey === 'scale_ticket_date'){
          return new Date(b.scale_ticket_date) - new Date(a.scale_ticket_date)
        } else if(dataKey === 'original_new_contract_id'){
          if(a.original_new_contract_id !== null && b.original_new_contract_id !== null) {
            const orgContracta =  a[dataKey].replace(/\D/g, '')
            const orgContractb =  b[dataKey].replace(/\D/g, '')
            return parseInt(orgContractb) - parseInt(orgContracta)
          }
          else
            return 0
        } else if(dataKey === 'company_name'){
          return a[dataKey].title.toLowerCase() > b[dataKey].title.toLowerCase() ? -1 : 1
        }  else if(isNaN(parseInt(a[dataKey]))){
          return a[dataKey].toLowerCase() > b[dataKey].toLowerCase() ? -1 : 1
        } else {
          return parseInt(b[dataKey].replace(/,/g, '')) - parseInt(a[dataKey].replace(/,/g, ''))
        } 
      })
    }
    return newTableData
  }
  return tableData
}

export const yearsOptionFactory = (middleYear, yearsBelow, yearsAbove) => {
  let counter = yearsAbove
  let index = 0
  let returnArr = []
  while (counter >= yearsBelow) {
    let year = (middleYear + counter).toString()
    returnArr.push({
      value: year,
      id: `${index}-${year}`
    })
    counter--
    index++
  }
  return returnArr
}

export const enogenUnitsCalculator = (fields, contract_type) => {
  const UNIT_SIZE = (contract_type === 'generic') ? 140000 : 80000
  if (fields.length) {
    let arrayOfSeedCount = []
    let arrayOfAcres = []
    fields.forEach(item => {
      arrayOfSeedCount.push(_.toNumber(item.acres) * _.toNumber(item.planting_rate))
      arrayOfAcres.push(_.toNumber(item.acres))
    })
    const totalSeed = _.sum(arrayOfSeedCount)
    const unitsNeeded = Math.ceil(totalSeed / UNIT_SIZE) || '0'
    return unitsNeeded
  } else {
    return null
  }
}

export const getISODateFromExcel = excelDate => {
  return (typeof excelDate === 'number' && new Date(Math.round((excelDate - 25568) * 86400 * 1000)).toISOString()) || null
}

export const convertDateFromISO = date => {
  return (date && date.split('T')[0].split('-').reverse().join('/')) || null
}

export const getMonthYearFromISO = string => {
  let key
  const months = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ]
  let arr = string.split('-')
  let month_index = parseInt(arr[1],10) - 1 
  let month = months[month_index]
  let JSdate = new Date(string)
  let year = JSdate.getFullYear() || null
  if (year && month) {
    key = `${month}-${year % 100}`
  }
  return {
    key
  }
}

export const stringToFloat = quantity => {
  if( typeof quantity === 'string'){
    return Math.round(parseFloat(quantity.replace(/\s|,/g, '')))
  }
  return quantity
}

export const getFieldBoundaryCenter = fieldBoundary => {
  if (fieldBoundary) {
    try {
      const feature = convertWktToJeoJson(fieldBoundary)
      return center(feature)
    } catch (error) {
      return null
    }
  }
  else return null
}

const convertWktToJeoJson = wkt => {
  return wellknown.parse(wkt)
}